<div
  class="general-settings"
  [class.general-settings--split]="!isWidgetGalleryHidden()"
>
  <div class="form-pane">
    @if (activeFormProperties.length > 0) {
      <app-dynamic-form
        [formProperties]="activeFormProperties"
        [formGroup]="formGroup"
        [fieldFilterString]="searchString"
      ></app-dynamic-form>
    }
  </div>

  @if (!isWidgetGalleryHidden()) {
    <aside class="widget-pane">
      <header class="widget-pane__header">
        <div class="widget-pane__title">
          {{
            "query-editor-general.widget-gallery.starter-widgets" | translate
          }}
          <span class="widget-pane__count">
            {{
              "query-editor-general.widget-gallery.selected-count"
                | translate: { count: selectedWidgetsCount() }
            }}
          </span>
        </div>
        <div class="widget-pane__hint">
          {{
            "query-editor-general.widget-gallery.pick-widgets-to-be-created-with-this-feed"
              | translate
          }}
        </div>
      </header>
      <div class="widget-pane__search">
        <fa-icon
          class="widget-pane__search-icon"
          [icon]="['fas', 'magnifying-glass']"
        ></fa-icon>
        <input
          type="text"
          class="widget-pane__search-input"
          [value]="widgetPresetSearch$ | async"
          (input)="onWidgetSearchChange($any($event.target).value)"
          [placeholder]="
            'query-editor-general.widget-gallery.search-widgets' | translate
          "
        />
        @if ((widgetPresetSearch$ | async)?.length) {
          <button
            type="button"
            class="widget-pane__search-clear"
            (click)="onWidgetSearchChange('')"
            [attr.aria-label]="'btn.clear' | translate"
          >
            <fa-icon [icon]="['fas', 'times']"></fa-icon>
          </button>
        }
      </div>
      <div class="widget-pane__body">
        @if (widgetPresetsLoading$ | async) {
          <div class="widget-pane__loading">
            <fa-icon
              [icon]="['fas', 'spinner']"
              size="2x"
              animation="spin-pulse"
            ></fa-icon>
          </div>
        }
        @if (!(widgetPresetsLoading$ | async)) {
          @if (filteredWidgetPresets$ | async; as presets) {
            @if (presets.length === 0 && !(widgetPresetSearch$ | async)) {
              <div class="widget-pane__empty">
                {{
                  "query-editor-general.widget-gallery.no-widget-templates-available-for-this-feed-type"
                    | translate
                }}
              </div>
            }
            @if (presets.length === 0 && (widgetPresetSearch$ | async)) {
              <div class="widget-pane__empty">
                {{
                  "query-editor-general.widget-gallery.no-widgets-match-search"
                    | translate: { term: widgetPresetSearch$ | async }
                }}
              </div>
            }
            @if (presets.length > 0) {
              <div class="widget-gallery">
                @for (
                  preset of presets;
                  track trackPresetById($index, preset)
                ) {
                  <app-widget-preset-card
                    [widgetPreset]="preset"
                    [selectable]="true"
                    [selected]="isPresetSelected(preset.id)"
                    [selectedVizTypeIds]="selectedVizTypeIdsFor(preset.id)"
                    [highlight]="(widgetPresetSearch$ | async) ?? ''"
                    (selectionToggle)="togglePreset(preset)"
                    (vizTypeToggle)="toggleVizType($event)"
                  ></app-widget-preset-card>
                }
              </div>
            }
          }
        }
      </div>
    </aside>
  }
</div>
